module.exports = __webpack_public_path__ + "static/media/lens3_blue.e9f4a630.png";